import { getHeaders, getMXIEndpoint } from "../../../helpers/endpoint";

export const REQUEST_MXI_CHAMPIONSHIP_CALENDAR = 'REQUEST_MXI_CHAMPIONSHIP_CALENDAR';
export const SUCCESS_MXI_CHAMPIONSHIP_CALENDAR = 'SUCCESS_MXI_CHAMPIONSHIP_CALENDAR';
export const FAIL_MXI_CHAMPIONSHIP_CALENDAR = 'FAIL_MXI_CHAMPIONSHIP_CALENDAR';

export const getChampionshipCalendar = (payload, scope, callBacks) => {
  return (dispatch, getState) => {
    if (callBacks?.onRequest) {
      callBacks.onRequest();
    }
    dispatch({type: REQUEST_MXI_CHAMPIONSHIP_CALENDAR, payload, scope});

    fetch(getMXIEndpoint('getMXIChampionshipCalendar', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (callBacks?.onError) {
            callBacks.onError();
          }
          dispatch({
            type: FAIL_MXI_CHAMPIONSHIP_CALENDAR,
            error: data.error,
            payload,
            scope,
          });
        } else {
          if (callBacks?.onSuccess) {
            callBacks.onSuccess(data);
          }
          dispatch(successChampionshipCalendar(data, payload, scope));
        }
      })
      .catch((error, type = FAIL_MXI_CHAMPIONSHIP_CALENDAR) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successChampionshipCalendar(response, payload, scope) {
  return dispatch => {
    dispatch({
      type: SUCCESS_MXI_CHAMPIONSHIP_CALENDAR,
      receivedAt: Date.now(),
      success: response.success,
      response,
      payload,
      scope,
    });
  };
}


// WEBPACK FOOTER //
// ./src/actions/entities/mxi/championshipCalendar.js